import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TSetAgreement = IAction<EPaymentActions.SET_AGREEMENT, { agreement: string, agreementEnc: string }>

const setAgreement = (agreement = '', agreementEnc = ''): TSetAgreement => ({
    type: EPaymentActions.SET_AGREEMENT,
    payload: {
        agreement,
        agreementEnc,
    },
});

export default setAgreement;
